/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorityType } from './authority-type';


export interface OperatorePraticaPatchForm { 
    authorities?: Set<AuthorityType>;
    comuni_ids?: Set<string>;
    authoritiesValid?: boolean;
    comuniIdsValid?: boolean;
}

